import React from 'react'
import { useProduct } from '../../../../__product/useProduct'
export function DirectionArrow({
    direction,
    height,
    width,
}: {
    direction: 'up' | 'down'
    height?: string
    width?: string
}) {
    const product = useProduct()
    const isTheWest = product === 'thewest'

    const colors = {
        up: isTheWest ? '#B30000' : '#FF5151',
        down: isTheWest ? '#158936' : '#009FDA',
    }

    if (direction === 'up') {
        return (
            <svg
                width={width ? width : '12'}
                height={height ? height : '12'}
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginLeft: '4px', marginRight: '2px' }}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 4L10 8H2L6 4Z"
                    fill={colors.up}
                />
            </svg>
        )
    }

    return (
        <svg
            width={width ? width : '12'}
            height={height ? height : '12'}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginLeft: '4px', marginRight: '2px' }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 8L10 4H2L6 8Z"
                fill={colors.down}
            />
        </svg>
    )
}
